import { render, staticRenderFns } from "./TheAppSettings.vue?vue&type=template&id=2fc4b5f6&"
import script from "./TheAppSettings.vue?vue&type=script&lang=js&"
export * from "./TheAppSettings.vue?vue&type=script&lang=js&"
import style0 from "./TheAppSettings.vue?vue&type=style&index=0&id=2fc4b5f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports